// 1: '中国电信',
// 2: '中国联通',
// 3: '中国移动',
// 4: '中国广电'
export var CarrierTypeDic;
(function (CarrierTypeDic) {
    CarrierTypeDic["TELECOM"] = "1";
    CarrierTypeDic["CUCC"] = "2";
    CarrierTypeDic["MIGU"] = "3";
    CarrierTypeDic["CBN"] = "4";
})(CarrierTypeDic || (CarrierTypeDic = {}));
// 实现支付类型对象
export const CarrierType = {
    ENUM: {
        [CarrierTypeDic.TELECOM]: '中国电信',
        [CarrierTypeDic.CUCC]: '中国联通',
        [CarrierTypeDic.MIGU]: '中国移动',
        [CarrierTypeDic.CBN]: '中国广电'
    },
    TELECOM: CarrierTypeDic.TELECOM,
    CUCC: CarrierTypeDic.CUCC,
    MIGU: CarrierTypeDic.MIGU,
    CBN: CarrierTypeDic.CBN
};
